// UI
export const UPDATE_AVAILABLE = "UPDATE_AVAILABLE";
